import { useState, useEffect, Dispatch } from 'react';
import { Modal, Button, Space } from 'antd';
import { Col, Input, Row, Form, DatePicker } from 'antd';
import { CALENDAR_LOCALE } from '../../../../utils/calendar-locale';
import { ColumnType } from 'antd/lib/table';
import { useWindowSize } from '../../../../hook/useWindowSize';
import TableSort from '../../../../components/TableSort';
import ModalAdicionarNotaManual from '../NotaManual';
import mask, { maskCurrency, maskUnd, maskDate } from '../../../../utils/mask';
import { Action } from 'typesafe-actions';
import { ApplicationState } from '../../../../store';
import { useDispatch, useSelector } from 'react-redux';
import {
  loadRequestNotas,
  filterNotas,
  cleanStateNotas,
} from '../../../../store/ducks/criarAtendimento/actions';
import TextFilter from '../../../../components/TextFilter';
import { ClearOutlined, CloseOutlined, FileSearchOutlined, PlusOutlined } from '@ant-design/icons';
import TextTable from '../../../../components/TextTable';
import moment from 'moment';

const ModalAdicionarNota = ({ parceiro, setAtualizarListaNotas }: any) => {
  const [visible, setVisible] = useState(false);
  const { RangePicker } = DatePicker;
  const { width }: any = useWindowSize();
  const [form] = Form.useForm();
  const dispatch = useDispatch<Dispatch<Action>>();
  const notas = useSelector((state: ApplicationState) => state.CriarAtendimento.notas);
  const filter = useSelector((state: ApplicationState) => state.CriarAtendimento.filter);
  const paginations = useSelector((state: ApplicationState) => state.CriarAtendimento.pagination);
  const loading = useSelector((state: ApplicationState) => state.CriarAtendimento.loading);
  let codigoParceiro: any;

  if (parceiro) codigoParceiro = parceiro;
  useEffect(() => {
    dispatch(loadRequestNotas(filter, codigoParceiro, paginations));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [codigoParceiro]);

  const listaNotasOcorrencia: any = JSON.parse(
    localStorage.getItem(window.location.pathname + `ListaNotas`) || '[]'
  );

  function incluirNota(listaNota: any) {
    setAtualizarListaNotas(true);
    localStorage.setItem(
      window.location.pathname + 'ListaNotas',
      JSON.stringify([...listaNotasOcorrencia, listaNota])
    );
    setVisible(false);
  }

  const columns: ColumnType<any>[] = [
    {
      title: '',
      dataIndex: '',
      key: 'selecionar',
      align: 'left',
      render: (listaNota) => {
        return (
          <Button
            type="link"
            onClick={() => incluirNota(listaNota)}
            style={{ fontSize: '12px', padding: '0px 5px' }}
            icon={<PlusOutlined />}
          >
            Selecionar
          </Button>
        );
      },
    },
    {
      title: 'Nota',
      dataIndex: 'numNota',
      key: 'numNota',
      align: 'center',
      render: (text) => {
        return text ? <TextTable>{text}</TextTable> : <TextTable>Não informado</TextTable>;
      },
    },

    {
      title: 'Emissão',
      dataIndex: 'dtEmissao',
      key: 'dtEmissao',
      align: 'center',
      render: (text) => {
        return text ? (
          <TextTable>{moment(text).format('LL')}</TextTable>
        ) : (
          <TextTable>Não informado</TextTable>
        );
      },
    },

    {
      title: 'Remetente',
      dataIndex: 'remetente',
      key: 'remetente',
      align: 'center',
      render: (text) => {
        return text ? (
          <TextTable>{mask('camelCase', text)}</TextTable>
        ) : (
          <TextTable>Não informado</TextTable>
        );
      },
    },

    {
      title: 'Origem/UF',
      dataIndex: 'origem',
      key: 'origem',
      align: 'center',
      render: (text) => {
        return text ? (
          <TextTable>{mask('camelCase', text)}</TextTable>
        ) : (
          <TextTable>Não informado</TextTable>
        );
      },
    },
    {
      title: 'Destinatário',
      dataIndex: 'destinatario',
      key: 'destinatario',
      align: 'center',
      render: (text) => {
        return text ? (
          <TextTable>{mask('camelCase', text)}</TextTable>
        ) : (
          <TextTable>Não informado</TextTable>
        );
      },
    },
    {
      title: 'Destino/UF',
      dataIndex: 'destino',
      key: 'destino',
      align: 'center',
      render: (text) => {
        return text ? (
          <TextTable>{mask('camelCase', text)}</TextTable>
        ) : (
          <TextTable>Não informado</TextTable>
        );
      },
    },
    {
      title: 'Peso',
      dataIndex: 'peso',
      key: 'peso',
      align: 'center',
      render: (text) => {
        return text ? (
          <TextTable>{maskUnd(text)} KG</TextTable>
        ) : (
          <TextTable>Não informado</TextTable>
        );
      },
    },
    {
      title: 'Valor',
      dataIndex: 'valor',
      key: 'valor',
      align: 'left',
      render(text) {
        return text ? (
          <TextTable>{maskCurrency(text)}</TextTable>
        ) : (
          <TextTable>Não informado</TextTable>
        );
      },
    },
  ];

  function onFinish({ numNota, periodo }: any) {
    let filtro = {
      numNota: numNota ? +numNota : 0,
      dtEmiIni: periodo ? maskDate(periodo[0]) : '',
      dtEmiFim: periodo ? maskDate(periodo[1]) : '',
    };
    dispatch(filterNotas(filtro));
    dispatch(loadRequestNotas(filtro, codigoParceiro));
  }
  const clearFilter = () => {
    const filtro = {};
    form.resetFields();
    localStorage.removeItem(`numNota${window.location.pathname}`);
    dispatch(cleanStateNotas());
    dispatch(loadRequestNotas(filtro, codigoParceiro, paginations));
  };

  function onFinishFailed(error: any) {
    dispatch(cleanStateNotas());
  }

  return (
    <>
      <Button type="primary" onClick={() => setVisible(true)}>
        Adicionar Nota
      </Button>

      <Modal
        title="Adicionar Nota"
        centered
        visible={visible}
        onCancel={() => setVisible(false)}
        width={1400}
        footer={[
          <Button onClick={() => setVisible(false)} icon={<CloseOutlined />}>
            Cancelar
          </Button>,
        ]}
      >
        <Form layout="vertical" form={form} onFinish={onFinish} onFinishFailed={onFinishFailed}>
          <Row gutter={24}>
            <Col md={6} sm={24} xs={24}>
              <Form.Item label={<TextFilter>Nº da nota</TextFilter>} name="numNota">
                <Input type="number" style={{ width: '100%' }} />
              </Form.Item>
            </Col>

            <Col md={6} sm={24} xs={24}>
              <Form.Item label={<TextFilter>Período de emissão</TextFilter>} name="periodo">
                <RangePicker
                  style={{ width: '100%' }}
                  locale={CALENDAR_LOCALE}
                  format="DD/MM/YYYY"
                />
              </Form.Item>
            </Col>
            <Space>
              <Col md={2} sm={24} xs={24}>
                <Form.Item label=" ">
                  <Button type="default" onClick={() => clearFilter()} icon={<ClearOutlined />}>
                    Limpar filtro
                  </Button>
                </Form.Item>
              </Col>
              <Col md={2} sm={24} xs={24}>
                <Form.Item label=" ">
                  <Button type="primary" htmlType="submit" icon={<FileSearchOutlined />}>
                    Pesquisar nota
                  </Button>
                </Form.Item>
              </Col>
            </Space>
          </Row>

          <Row gutter={24}>
            <Col md={6} sm={24} xs={24} style={{ width: '100%' }}>
              <Form.Item label=" ">
                <ModalAdicionarNotaManual
                  setAtualizarListaNotas={setAtualizarListaNotas}
                  setVisible={setVisible}
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>

        {width > 768 && (
          <TableSort
            style={{ fontSize: 10, display: 'inline' }}
            columns={columns}
            scroll={{ x: 2000 }}
            dataSource={notas}
            pagination={paginations}
            loading={loading}
            onChange={(pagination: any, filters: any) => {
              dispatch(
                loadRequestNotas(
                  filter,
                  filter?.codParceiro ? [+filter.codParceiro] : codigoParceiro,
                  pagination
                )
              );
            }}
          />
        )}

        {width < 768 && (
          <TableSort
            style={{ fontSize: 10, display: 'inline' }}
            columns={columns}
            scroll={{ x: 1200 }}
            dataSource={notas}
          />
        )}
      </Modal>
    </>
  );
};

export default ModalAdicionarNota;
